<template>
  <div
    v-if="resultadoValidacao && resultadoValidacao['resumo'] && resultadoValidacao['resumo']['qtd_conjuntos']"
    class="table-container"
  >
    <table v-if="!transporMatriz" cellspacing="0" border="0">
      <tr>
        <td class="celula-conj">CONJ</td>
        <td v-for="conj in resultadoValidacao['conj']" :key="conj" class="celula-conj">
          {{ conj }}
        </td>
      </tr>
      <tr v-for="campoDec in camposDec" :key="campoDec">
        <td
          :style="{
            background: '#BDD7EE',
            color: '#000000'
          }"
        >
          {{ campoDec.toUpperCase() }}_PERC
        </td>
        <td
          v-for="(conj, i) in resultadoValidacao['conj']"
          :key="i"
          :title="campoDec.toUpperCase() + '_PERC do CONJ ' + conj"
          :style="{
            background: getBackgroundColorByStatus(resultadoValidacao[campoDec]['status'][i]),
            color: getTextColorByStatus(resultadoValidacao[campoDec]['status'][i])
          }"
        >
          <span v-if="statusConjuntos">
            <status-validacao :status="resultadoValidacao[campoDec]['status'][i]" />
          </span>
          <span v-else>
            {{ resultadoValidacao[campoDec]['perc'][i] | parseNumberToFloatBR }}
          </span>
        </td>
      </tr>
      <tr v-for="campoFec in camposFec" :key="campoFec">
        <td
          :style="{
            background: '#203864',
            color: '#ffffff'
          }"
        >
          {{ campoFec.toUpperCase() }}_PERC
        </td>
        <td
          v-for="(conj, i) in resultadoValidacao['conj']"
          :key="i"
          :title="campoFec.toUpperCase() + '_PERC do CONJ ' + conj"
          :style="{
            background: getBackgroundColorByStatus(resultadoValidacao[campoFec]['status'][i]),
            color: getTextColorByStatus(resultadoValidacao[campoFec]['status'][i])
          }"
        >
          <span v-if="statusConjuntos">
            <status-validacao :status="resultadoValidacao[campoFec]['status'][i]" />
          </span>
          <span v-else>
            {{ resultadoValidacao[campoFec]['perc'][i] | parseNumberToFloatBR }}
          </span>
        </td>
      </tr>
    </table>
    <table v-if="transporMatriz" cellspacing="0" border="0">
      <tr>
        <td class="celula-conj">CONJ</td>
        <td
          v-for="campoDec in camposDec"
          :key="campoDec"
          :style="{
            background: '#BDD7EE',
            color: '#000000'
          }"
        >
          {{ campoDec.toUpperCase() }}_PERC
        </td>
        <td
          v-for="campoFec in camposFec"
          :key="campoFec"
          :style="{
            background: '#203864',
            color: '#ffffff'
          }"
        >
          {{ campoFec.toUpperCase() }}_PERC
        </td>
      </tr>
      <tr v-for="(conj, i) in resultadoValidacao['conj']" :key="conj">
        <td class="celula-conj">
          {{ conj }}
        </td>
        <td
          v-for="campoDec in camposDec"
          :key="campoDec"
          :title="campoDec.toUpperCase() + '_PERC do CONJ ' + conj"
          :style="{
            background: getBackgroundColorByStatus(resultadoValidacao[campoDec]['status'][i]),
            color: getTextColorByStatus(resultadoValidacao[campoDec]['status'][i])
          }"
        >
          <span v-if="statusConjuntos">
            <status-validacao :status="resultadoValidacao[campoDec]['status'][i]" />
          </span>
          <span v-else>
            {{ resultadoValidacao[campoDec]['perc'][i] | parseNumberToFloatBR }}
          </span>
        </td>
        <td
          v-for="campoFec in camposFec"
          :key="campoFec"
          :title="campoFec.toUpperCase() + '_PERC do CONJ ' + conj"
          :style="{
            background: getBackgroundColorByStatus(resultadoValidacao[campoFec]['status'][i]),
            color: getTextColorByStatus(resultadoValidacao[campoFec]['status'][i])
          }"
        >
          <span v-if="statusConjuntos">
            <status-validacao :status="resultadoValidacao[campoFec]['status'][i]" />
          </span>
          <span v-else>
            {{ resultadoValidacao[campoFec]['perc'][i] | parseNumberToFloatBR }}
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import TabelaResultadoValidacaoMixins from './TabelaResultadoValidacaoMixins';
  import StatusValidacao from './StatusValidacao.vue';
  export default {
    name: 'TabelaResultadoValidacaoDecFec',
    components: { StatusValidacao },
    mixins: [TabelaResultadoValidacaoMixins]
  };
</script>

<style>
  .table-container {
    max-width: 100%;
    overflow-x: scroll;
    padding-bottom: 20px;
  }
  .table-container table td {
    font-family: 'Times New Roman', Times, serif;
    font-size: 12px;
    border: 1px solid #000000;
    padding: 5px;
    text-align: center;
  }
  .celula-conj {
    background-color: #ffe699;
    font-weight: bold;
    text-align: center;
  }
</style>
